import { FormattedAxnSession } from "@idw-types/data/management-console/axn";

export enum AxnSessionsActionTypes {
    SET_AXN_SESSIONS_LOADING = "SET_AXN_SESSIONS_LOADING",
    SET_AXN_SESSIONS = "SET_AXN_SESSIONS"
}

type SetAxnSessionsLoadingAction = {
    type: AxnSessionsActionTypes.SET_AXN_SESSIONS_LOADING,
    payload: { isLoading: boolean; }
};

export const setAxnSessionsLoading = (isLoading: boolean): SetAxnSessionsLoadingAction => ({
    type: AxnSessionsActionTypes.SET_AXN_SESSIONS_LOADING,
    payload: { isLoading }
});

type SetAxnSessionsAction = {
    type: AxnSessionsActionTypes.SET_AXN_SESSIONS,
    payload: { axnSessions: Array<FormattedAxnSession>; }
}

export const setAxnSessions = (axnSessions: Array<FormattedAxnSession>): SetAxnSessionsAction => ({
    type: AxnSessionsActionTypes.SET_AXN_SESSIONS,
    payload: { axnSessions }
});

export type AxnSessionsActions =
    SetAxnSessionsLoadingAction |
    SetAxnSessionsAction